import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select.tsx"
import type { AggregationMode } from "@/types/dataPointTypes.ts"

export default function AggregationModeSelector({
  value,
  onChange,
}: {
  value: AggregationMode
  onChange: (a: AggregationMode) => void
}) {
  return (
    <Select value={value} onValueChange={(v: AggregationMode) => onChange(v)}>
      <SelectTrigger className="w-full">
        <SelectValue placeholder="Select mode" />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          <SelectLabel>Aggregation Modes</SelectLabel>
          <SelectItem value="Average">Average</SelectItem>
          <SelectItem value="SimpleAverage">Simple Average</SelectItem>
          <SelectItem value="LastValue">Last Value</SelectItem>
          <SelectItem value="Sum">Sum</SelectItem>
          <SelectItem value="Minimum">Minimum</SelectItem>
          <SelectItem value="Maximum">Maximum</SelectItem>
          <SelectItem value="Count">Count</SelectItem>
          <SelectItem value="Range">Range</SelectItem>
          <SelectItem value="Variance">Variance</SelectItem>
          <SelectItem value="StandardDeviation">Standard Deviation</SelectItem>
        </SelectGroup>
      </SelectContent>
    </Select>
  )
}
